<template>
    <div id="CompaniesGeo" class="starter-template" :key="key">
        <b-container fluid>
            <b-row class="text-center" style="padding-top: 6px">
                <b-col>
                    <div class="text-center shad">
                        <h4 class="txtShad">{{ $t('COMPANIES') }}</h4>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <ChooseCompany
                v-on:retToOut="retToOut"
                :key="myKey"
                v-if="chooseCompany"
                ref="CompanyChooser"
        />


        <br>
        <b-container fluid>
            <b-row >
                <b-col>
                    <b-table class="backWhite descOuter mt-2"
                             id="listTable"
                             responsive
                             selectable
                             :items="items"
                             :fields="fields"
                             :per-page=0
                             :current-page="curPage"
                             striped
                             head-row-variant="info"
                             @row-selected="onRowSelected"
                    >
                    </b-table>

                    <b-pagination v-if="listLength>10"
                                  v-model="curPage"
                                  :total-rows="rows"
                                  :per-page="perPage"
                                  aria-controls="listTable"
                                  pills
                    ></b-pagination>
                </b-col>
            </b-row>
            <br><br><br>

            <div class="modalConf">
                <b-modal id="modalConf">
                    <div class="d-block text-center">
                        <h4>{{$t('SURE')}}</h4>
                    </div>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="success" @click="cancel()">{{$t('CANCEL')}}</b-button>
                        <b-button variant="danger" @click="canAct()">{{$t('GO_ON')}}</b-button>
                    </template>
                </b-modal>
            </div>


        </b-container>
        <b-container fluid class = "footer text-center">

            <center>
                <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                    <a v-b-popover.hover.top="this.$t('SHOW')" title="" class="shBt">
                        <b-form-radio value="Company"><font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('OUTINGS')" title="">
                        <b-form-radio value="CompanyOutingsList"><font-awesome-icon icon="folder-open" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('REF_GEO')" title="" v-if="admin">
                        <b-form-radio value="RefAdd"><font-awesome-icon icon="book" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('EDIT')" title="">
                        <b-form-radio value="ManageCompany"><font-awesome-icon icon="edit" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('DELETE')" title="" v-if="author || admin" class="shBt">
                        <b-form-radio value="deleteCompany"><font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }" /></b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('HELP')" title="" v-if="author || admin" class="shBt">
                        <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
                    </a>
                </b-form-radio-group>
            </center>

        </b-container>


    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BTable, BPagination, BModal, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
import ChooseCompany from "./ChooseCompany.vue";

export default {
  name: 'CompaniesGeo',
  components: {
    ChooseCompany,
    BContainer, BRow, BCol, BButton, BTable, BPagination, BModal, BFormRadio, BFormRadioGroup
  },
  data: function() {
    return {
        key: 0,
        userName: '',
        curUserName: '',
        itemName: '',
        homeUrl: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        intLoc: this.$i18n.locale,
        item: {},
        items: [{}],
        selected: 'Company',
        listLength: 1,
        perPage: 10,
        curPage: 1,
        geoType: '',
        chsnGeo: '',
        untieGeo: false,
        showMapBtn: false,
        individ: 'false',
        fixOld: false,
        chooseCompany: true,
        myKey: 0,
        chToName: 'whereTo',
        scope: 'travels',
        title: '',
        metaDesc: ''
    }
  },
  metaInfo() {
     return {
        title: `${this.title}`,
        meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
        ]
     }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    this.descMeta();
  },
  methods: {
    async getGeoCompanies() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoCompanies', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPage
                }
            });
            this.items = response.data.itemList;
            this.listLength = response.data.listLen;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('CompaniesGeo: getGeoCompanies() '+error.message);
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPage = 1;
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.items = [];
    },
    retToOut() {
        this.companyName = this.$refs.CompanyChooser.getCom();
        this.homeUrl = this.$refs.CompanyChooser.getHomeUrl();
        //alert(this.homeUrl);
        this.chooseCompany = false;
        this.ediKey++;
        if(this.selected==='Company') {
            window.open(this.homeUrl,'_blank');
        }
        else if(this.selected==='ManageCompany') {
            this.$router.push({
               path: '/ManageCompany/'+this.$addEncHyp(this.companyName),
            })
        }
        else if(this.selected==='RefAdd') {
            this.$router.push({
               path: '/ManageRef',
               query: {
                    userName: this.userName,
                    itemName: this.$addEncHyp(this.companyName),
                    itemType: 'c'
               }
            })
        }
        else if(this.selected==='CompanyOutingsList') {
            this.$router.push({
               path: '/CompanyOutingsList/'+this.$addEncHyp(this.companyName),
            })
        }
        else this.$bvModal.show('modalConf');
    },
    async canAct() {
        this.$bvModal.hide('modalConf');
        try {
            await this.$http.get('/'+this.selected, {
                params: {
                    companyName: this.companyName,
                    userName: this.curUserName
                }
            });
            this.$showMsg(this.$t('DONE'));
            this.reloadList();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },

/*
    onRowSelectedC(items) {
        this.item = items[0];
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
            this.$router.push({
                path: '/Tour/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
            })
        }
    },
*/
    clear() {
        this.countryRu = '',
        this.countryEn = '',
        this.districtRu = '',
        this.districtEn = '',
        this.cityRu = '',
        this.cityEn = '',
        this.geoType = '';
        this.items = [{}];
        this.listLength = 0;
    },
    areaMap() {
        if(!this.countryEn) return;
        let country = this.countryEn;
        let district = this.districtEn ? this.districtEn : '_';
        let city = this.cityEn ? this.cityEn : '_';
        //console.log(country, district, city);
        this.$router.push({
            //name: 'AreaMap',
            //name: 'AreaMap', params: { country: country, district: district, city: city }
            path: '/Map/AreaMap/'+country+'/'+district+'/'+city
        })
    },
    async untie() {
        this.$bvModal.hide('modal-untie');
        this.untieGeo = false;
        //console.log(this.item.userName, this.item.itemName);
        try {
            const response = await this.$http.get('/refDel', {
                params: {
                    userName: this.item.userName,
                    itemName: this.item.itemName,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    intLoc: this.intLoc
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    getGeoTo() {
        let chosenGeo = this.$refs.getGeoTo.getChosenGeo();
            if(chosenGeo.init) this.clear();
            if(!chosenGeo.countryEn) return;
            this.countryRu = chosenGeo.countryRu;
            this.countryEn = chosenGeo.countryEn;
            this.districtRu = chosenGeo.districtRu;
            this.districtEn = chosenGeo.districtEn;
            this.cityRu = chosenGeo.cityRu;
            this.cityEn = chosenGeo.cityEn;
            //console.log(this.countryRu, this.districtRu, this.cityRu);
            if(this.cityEn) this.geoType = 'city';
            else if(this.districtEn) this.geoType = 'district';
            else this.geoType = 'country';
            this.getGeoCompanies();
    },
    async del() {
        this.$bvModal.hide('modal-del');
        try {
            const response = await this.$http.get('/rmGeoItem', {
                params: {
                    refType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Путешествия и достопримечательности';
            this.metaDesc = 'Каталог путешествий и достопримечательностей по странам и городам';
        }
        else {
            this.title = 'Travels and attractions'
            this.metaDesc = 'Directory of travels and attractions by countries and cities';
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
        //this.getCountries();
    },
    curPage: function() {
        if(!this.init) this.getGeoCompanies();
    },
  },
  computed: {
    rows() {
        return this.listLength;
    },
    author() { return this.userName === this.curUserName },
    admin() { return this.curUserName === 'admin' },
    fields() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'userName', label: 'URL' },
        //{ key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    },
  }
}

</script>

<style>
</style>